import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IntegrityService } from './services/integrity.service';

@NgModule({
	declarations: [],
	imports: [
		CommonModule
	],
	providers: [
		IntegrityService
	]
})
export class IntegrityModule { }
